// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VideoskanningRouteImport } from './routes/videoskanning'
import { Route as VarforKostarDetRouteImport } from './routes/varfor-kostar-det'
import { Route as TipsRouteImport } from './routes/tips'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SkapaRouteImport } from './routes/skapa'
import { Route as SaFungerarDetRouteImport } from './routes/sa-fungerar-det'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReglerRouteImport } from './routes/regler'
import { Route as PriserRouteImport } from './routes/priser'
import { Route as OmRouteImport } from './routes/om'
import { Route as IntegritetspolicyRouteImport } from './routes/integritetspolicy'
import { Route as GlomtLosenordRouteImport } from './routes/glomt-losenord'
import { Route as CookiepolicyRouteImport } from './routes/cookiepolicy'
import { Route as BekraftadRouteImport } from './routes/bekraftad'
import { Route as AnvandarvillkorRouteImport } from './routes/anvandarvillkor'
import { Route as AnnonserRouteImport } from './routes/annonser'
import { Route as SplatRouteImport } from './routes/$'
import { Route as EsRouteRouteImport } from './routes/es.route'
import { Route as EnRouteRouteImport } from './routes/en.route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as KopaOchSaljaIndexRouteImport } from './routes/kopa-och-salja.index'
import { Route as JamforIndexRouteImport } from './routes/jamfor.index'
import { Route as GuiderIndexRouteImport } from './routes/guider.index'
import { Route as ForetagIndexRouteImport } from './routes/foretag.index'
import { Route as SaljaKategoriRouteImport } from './routes/salja.$kategori'
import { Route as OrderSparningTrackingRouteImport } from './routes/order-sparning.$tracking'
import { Route as KopaOchSaljaOrtRouteImport } from './routes/kopa-och-salja.$ort'
import { Route as JamforTjanstRouteImport } from './routes/jamfor.$tjanst'
import { Route as GuiderSlugRouteImport } from './routes/guider.$slug'
import { Route as ForetagListaRouteImport } from './routes/foretag.lista'
import { Route as ForetagSlugRouteImport } from './routes/foretag.$slug'
import { Route as ASlugRouteImport } from './routes/a.$slug'
import { Route as EsIndexRouteImport } from './routes/es.index'
import { Route as EsTerminosRouteImport } from './routes/es.terminos'
import { Route as EsSoporteRouteImport } from './routes/es.soporte'
import { Route as EsSobreNosotrosRouteImport } from './routes/es.sobre-nosotros'
import { Route as EsReglasRouteImport } from './routes/es.reglas'
import { Route as EsPrivacidadRouteImport } from './routes/es.privacidad'
import { Route as EsPreciosRouteImport } from './routes/es.precios'
import { Route as EsPorQueCuestaRouteImport } from './routes/es.por-que-cuesta'
import { Route as EsOlvideContrasenaRouteImport } from './routes/es.olvide-contrasena'
import { Route as EsGuiasRouteImport } from './routes/es.guias'
import { Route as EsEscaneoVideoRouteImport } from './routes/es.escaneo-video'
import { Route as EsEmpresasRouteImport } from './routes/es.empresas'
import { Route as EsCrearRouteImport } from './routes/es.crear'
import { Route as EsCookiesRouteImport } from './routes/es.cookies'
import { Route as EsConsejosRouteImport } from './routes/es.consejos'
import { Route as EsComprarYVenderRouteImport } from './routes/es.comprar-y-vender'
import { Route as EsCompararRouteImport } from './routes/es.comparar'
import { Route as EsComoFuncionaRouteImport } from './routes/es.como-funciona'
import { Route as EsAnunciosRouteImport } from './routes/es.anuncios'
import { Route as EnIndexRouteImport } from './routes/en.index'
import { Route as EnWhyItCostsRouteImport } from './routes/en.why-it-costs'
import { Route as EnVideoScanRouteImport } from './routes/en.video-scan'
import { Route as EnTipsRouteImport } from './routes/en.tips'
import { Route as EnTermsRouteImport } from './routes/en.terms'
import { Route as EnSupportRouteImport } from './routes/en.support'
import { Route as EnRulesRouteImport } from './routes/en.rules'
import { Route as EnPrivacyRouteImport } from './routes/en.privacy'
import { Route as EnPricingRouteImport } from './routes/en.pricing'
import { Route as EnListingsRouteImport } from './routes/en.listings'
import { Route as EnHowItWorksRouteImport } from './routes/en.how-it-works'
import { Route as EnGuidesRouteImport } from './routes/en.guides'
import { Route as EnForgotPasswordRouteImport } from './routes/en.forgot-password'
import { Route as EnCreateRouteImport } from './routes/en.create'
import { Route as EnCookiesRouteImport } from './routes/en.cookies'
import { Route as EnCompareRouteImport } from './routes/en.compare'
import { Route as EnBuyAndSellRouteImport } from './routes/en.buy-and-sell'
import { Route as EnBusinessesRouteImport } from './routes/en.businesses'
import { Route as EnAboutRouteImport } from './routes/en.about'
import { Route as AuthenticatedStatistikRouteImport } from './routes/_authenticated/statistik'
import { Route as AuthenticatedSparadeRouteImport } from './routes/_authenticated/sparade'
import { Route as AuthenticatedProfilRouteImport } from './routes/_authenticated/profil'
import { Route as AuthenticatedOversiktRouteImport } from './routes/_authenticated/oversikt'
import { Route as AuthenticatedMinaPrylarRouteImport } from './routes/_authenticated/mina-prylar'
import { Route as AuthenticatedMinaBudRouteImport } from './routes/_authenticated/mina-bud'
import { Route as AuthenticatedMinaArendenRouteImport } from './routes/_authenticated/mina-arenden'
import { Route as AuthenticatedMinaAnnonserRouteImport } from './routes/_authenticated/mina-annonser'
import { Route as AuthenticatedMinaAffarerRouteImport } from './routes/_authenticated/mina-affarer'
import { Route as AuthenticatedMinNivaRouteImport } from './routes/_authenticated/min-niva'
import { Route as AuthenticatedMeddelandenRouteImport } from './routes/_authenticated/meddelanden'
import { Route as AuthenticatedLyftRouteImport } from './routes/_authenticated/lyft'
import { Route as AuthenticatedKontoRouteImport } from './routes/_authenticated/konto'
import { Route as AuthenticatedForetagsverktygRouteImport } from './routes/_authenticated/foretagsverktyg'
import { Route as AuthenticatedBevakningarRouteImport } from './routes/_authenticated/bevakningar'
import { Route as AuthenticatedAdresserRouteImport } from './routes/_authenticated/adresser'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedRedigeraSlugRouteImport } from './routes/_authenticated/redigera.$slug'
import { Route as AuthenticatedOrderIdRouteImport } from './routes/_authenticated/order.$id'
import { Route as AuthenticatedKvittoIdRouteImport } from './routes/_authenticated/kvitto.$id'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminTvisterRouteImport } from './routes/_authenticated/admin/tvister'
import { Route as AuthenticatedAdminSupportRouteImport } from './routes/_authenticated/admin/support'
import { Route as AuthenticatedAdminStatistikRouteImport } from './routes/_authenticated/admin/statistik'
import { Route as AuthenticatedAdminSokordRouteImport } from './routes/_authenticated/admin/sokord'
import { Route as AuthenticatedAdminSkannlabbRouteImport } from './routes/_authenticated/admin/skannlabb'
import { Route as AuthenticatedAdminSidorRouteImport } from './routes/_authenticated/admin/sidor'
import { Route as AuthenticatedAdminRevisionsloggRouteImport } from './routes/_authenticated/admin/revisionslogg'
import { Route as AuthenticatedAdminPushnotiserRouteImport } from './routes/_authenticated/admin/pushnotiser'
import { Route as AuthenticatedAdminPlankostnaderRouteImport } from './routes/_authenticated/admin/plankostnader'
import { Route as AuthenticatedAdminOrdrarRouteImport } from './routes/_authenticated/admin/ordrar'
import { Route as AuthenticatedAdminModereringRouteImport } from './routes/_authenticated/admin/moderering'
import { Route as AuthenticatedAdminMejlRouteImport } from './routes/_authenticated/admin/mejl'
import { Route as AuthenticatedAdminMarknadsminneRouteImport } from './routes/_authenticated/admin/marknadsminne'
import { Route as AuthenticatedAdminLanderRouteImport } from './routes/_authenticated/admin/lander'
import { Route as AuthenticatedAdminKonRouteImport } from './routes/_authenticated/admin/kon'
import { Route as AuthenticatedAdminForetagRouteImport } from './routes/_authenticated/admin/foretag'
import { Route as AuthenticatedAdminButiksunderlagRouteImport } from './routes/_authenticated/admin/butiksunderlag'
import { Route as AuthenticatedAdminBrandingRouteImport } from './routes/_authenticated/admin/branding'
import { Route as AuthenticatedAdminBlocketRouteImport } from './routes/_authenticated/admin/blocket'
import { Route as AuthenticatedAdminBildsokRouteImport } from './routes/_authenticated/admin/bildsok'
import { Route as AuthenticatedAdminBetalningFraktRouteImport } from './routes/_authenticated/admin/betalning-frakt'
import { Route as AuthenticatedAdminAppunderlagRouteImport } from './routes/_authenticated/admin/appunderlag'
import { Route as AuthenticatedAdminApplageRouteImport } from './routes/_authenticated/admin/applage'
import { Route as AuthenticatedAdminAnvandareRouteImport } from './routes/_authenticated/admin/anvandare'
import { Route as AuthenticatedAdminAnnonserRouteImport } from './routes/_authenticated/admin/annonser'
import { Route as AuthenticatedAdminAnmalningarRouteImport } from './routes/_authenticated/admin/anmalningar'
import { Route as AuthenticatedAdminAiKostnaderRouteImport } from './routes/_authenticated/admin/ai-kostnader'
import { Route as AuthenticatedAdminVisaSomUserIdRouteImport } from './routes/_authenticated/admin/visa-som.$userId'
import { Route as AuthenticatedAdminTvisterIdRouteImport } from './routes/_authenticated/admin/tvister_.$id'
import { Route as AuthenticatedAdminOrdrarIdRouteImport } from './routes/_authenticated/admin/ordrar_.$id'
import { Route as AuthenticatedAdminAnvandareUserIdRouteImport } from './routes/_authenticated/admin/anvandare_.$userId'
import { Route as AuthenticatedAdminAnnonsSlugRouteImport } from './routes/_authenticated/admin/annons.$slug'

const VideoskanningRoute = VideoskanningRouteImport.update({
            id: '/videoskanning',path: '/videoskanning',getParentRoute: () => rootRouteImport
          })
const VarforKostarDetRoute = VarforKostarDetRouteImport.update({
            id: '/varfor-kostar-det',path: '/varfor-kostar-det',getParentRoute: () => rootRouteImport
          })
const TipsRoute = TipsRouteImport.update({
            id: '/tips',path: '/tips',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const SkapaRoute = SkapaRouteImport.update({
            id: '/skapa',path: '/skapa',getParentRoute: () => rootRouteImport
          })
const SaFungerarDetRoute = SaFungerarDetRouteImport.update({
            id: '/sa-fungerar-det',path: '/sa-fungerar-det',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ReglerRoute = ReglerRouteImport.update({
            id: '/regler',path: '/regler',getParentRoute: () => rootRouteImport
          })
const PriserRoute = PriserRouteImport.update({
            id: '/priser',path: '/priser',getParentRoute: () => rootRouteImport
          })
const OmRoute = OmRouteImport.update({
            id: '/om',path: '/om',getParentRoute: () => rootRouteImport
          })
const IntegritetspolicyRoute = IntegritetspolicyRouteImport.update({
            id: '/integritetspolicy',path: '/integritetspolicy',getParentRoute: () => rootRouteImport
          })
const GlomtLosenordRoute = GlomtLosenordRouteImport.update({
            id: '/glomt-losenord',path: '/glomt-losenord',getParentRoute: () => rootRouteImport
          })
const CookiepolicyRoute = CookiepolicyRouteImport.update({
            id: '/cookiepolicy',path: '/cookiepolicy',getParentRoute: () => rootRouteImport
          })
const BekraftadRoute = BekraftadRouteImport.update({
            id: '/bekraftad',path: '/bekraftad',getParentRoute: () => rootRouteImport
          })
const AnvandarvillkorRoute = AnvandarvillkorRouteImport.update({
            id: '/anvandarvillkor',path: '/anvandarvillkor',getParentRoute: () => rootRouteImport
          })
const AnnonserRoute = AnnonserRouteImport.update({
            id: '/annonser',path: '/annonser',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const EsRouteRoute = EsRouteRouteImport.update({
            id: '/es',path: '/es',getParentRoute: () => rootRouteImport
          })
const EnRouteRoute = EnRouteRouteImport.update({
            id: '/en',path: '/en',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const KopaOchSaljaIndexRoute = KopaOchSaljaIndexRouteImport.update({
            id: '/kopa-och-salja/',path: '/kopa-och-salja/',getParentRoute: () => rootRouteImport
          })
const JamforIndexRoute = JamforIndexRouteImport.update({
            id: '/jamfor/',path: '/jamfor/',getParentRoute: () => rootRouteImport
          })
const GuiderIndexRoute = GuiderIndexRouteImport.update({
            id: '/guider/',path: '/guider/',getParentRoute: () => rootRouteImport
          })
const ForetagIndexRoute = ForetagIndexRouteImport.update({
            id: '/foretag/',path: '/foretag/',getParentRoute: () => rootRouteImport
          })
const SaljaKategoriRoute = SaljaKategoriRouteImport.update({
            id: '/salja/$kategori',path: '/salja/$kategori',getParentRoute: () => rootRouteImport
          })
const OrderSparningTrackingRoute = OrderSparningTrackingRouteImport.update({
            id: '/order-sparning/$tracking',path: '/order-sparning/$tracking',getParentRoute: () => rootRouteImport
          })
const KopaOchSaljaOrtRoute = KopaOchSaljaOrtRouteImport.update({
            id: '/kopa-och-salja/$ort',path: '/kopa-och-salja/$ort',getParentRoute: () => rootRouteImport
          })
const JamforTjanstRoute = JamforTjanstRouteImport.update({
            id: '/jamfor/$tjanst',path: '/jamfor/$tjanst',getParentRoute: () => rootRouteImport
          })
const GuiderSlugRoute = GuiderSlugRouteImport.update({
            id: '/guider/$slug',path: '/guider/$slug',getParentRoute: () => rootRouteImport
          })
const ForetagListaRoute = ForetagListaRouteImport.update({
            id: '/foretag/lista',path: '/foretag/lista',getParentRoute: () => rootRouteImport
          })
const ForetagSlugRoute = ForetagSlugRouteImport.update({
            id: '/foretag/$slug',path: '/foretag/$slug',getParentRoute: () => rootRouteImport
          })
const ASlugRoute = ASlugRouteImport.update({
            id: '/a/$slug',path: '/a/$slug',getParentRoute: () => rootRouteImport
          })
const EsIndexRoute = EsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EsRouteRoute
          })
const EsTerminosRoute = EsTerminosRouteImport.update({
            id: '/terminos',path: '/terminos',getParentRoute: () => EsRouteRoute
          })
const EsSoporteRoute = EsSoporteRouteImport.update({
            id: '/soporte',path: '/soporte',getParentRoute: () => EsRouteRoute
          })
const EsSobreNosotrosRoute = EsSobreNosotrosRouteImport.update({
            id: '/sobre-nosotros',path: '/sobre-nosotros',getParentRoute: () => EsRouteRoute
          })
const EsReglasRoute = EsReglasRouteImport.update({
            id: '/reglas',path: '/reglas',getParentRoute: () => EsRouteRoute
          })
const EsPrivacidadRoute = EsPrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => EsRouteRoute
          })
const EsPreciosRoute = EsPreciosRouteImport.update({
            id: '/precios',path: '/precios',getParentRoute: () => EsRouteRoute
          })
const EsPorQueCuestaRoute = EsPorQueCuestaRouteImport.update({
            id: '/por-que-cuesta',path: '/por-que-cuesta',getParentRoute: () => EsRouteRoute
          })
const EsOlvideContrasenaRoute = EsOlvideContrasenaRouteImport.update({
            id: '/olvide-contrasena',path: '/olvide-contrasena',getParentRoute: () => EsRouteRoute
          })
const EsGuiasRoute = EsGuiasRouteImport.update({
            id: '/guias',path: '/guias',getParentRoute: () => EsRouteRoute
          })
const EsEscaneoVideoRoute = EsEscaneoVideoRouteImport.update({
            id: '/escaneo-video',path: '/escaneo-video',getParentRoute: () => EsRouteRoute
          })
const EsEmpresasRoute = EsEmpresasRouteImport.update({
            id: '/empresas',path: '/empresas',getParentRoute: () => EsRouteRoute
          })
const EsCrearRoute = EsCrearRouteImport.update({
            id: '/crear',path: '/crear',getParentRoute: () => EsRouteRoute
          })
const EsCookiesRoute = EsCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => EsRouteRoute
          })
const EsConsejosRoute = EsConsejosRouteImport.update({
            id: '/consejos',path: '/consejos',getParentRoute: () => EsRouteRoute
          })
const EsComprarYVenderRoute = EsComprarYVenderRouteImport.update({
            id: '/comprar-y-vender',path: '/comprar-y-vender',getParentRoute: () => EsRouteRoute
          })
const EsCompararRoute = EsCompararRouteImport.update({
            id: '/comparar',path: '/comparar',getParentRoute: () => EsRouteRoute
          })
const EsComoFuncionaRoute = EsComoFuncionaRouteImport.update({
            id: '/como-funciona',path: '/como-funciona',getParentRoute: () => EsRouteRoute
          })
const EsAnunciosRoute = EsAnunciosRouteImport.update({
            id: '/anuncios',path: '/anuncios',getParentRoute: () => EsRouteRoute
          })
const EnIndexRoute = EnIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EnRouteRoute
          })
const EnWhyItCostsRoute = EnWhyItCostsRouteImport.update({
            id: '/why-it-costs',path: '/why-it-costs',getParentRoute: () => EnRouteRoute
          })
const EnVideoScanRoute = EnVideoScanRouteImport.update({
            id: '/video-scan',path: '/video-scan',getParentRoute: () => EnRouteRoute
          })
const EnTipsRoute = EnTipsRouteImport.update({
            id: '/tips',path: '/tips',getParentRoute: () => EnRouteRoute
          })
const EnTermsRoute = EnTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => EnRouteRoute
          })
const EnSupportRoute = EnSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => EnRouteRoute
          })
const EnRulesRoute = EnRulesRouteImport.update({
            id: '/rules',path: '/rules',getParentRoute: () => EnRouteRoute
          })
const EnPrivacyRoute = EnPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => EnRouteRoute
          })
const EnPricingRoute = EnPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => EnRouteRoute
          })
const EnListingsRoute = EnListingsRouteImport.update({
            id: '/listings',path: '/listings',getParentRoute: () => EnRouteRoute
          })
const EnHowItWorksRoute = EnHowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => EnRouteRoute
          })
const EnGuidesRoute = EnGuidesRouteImport.update({
            id: '/guides',path: '/guides',getParentRoute: () => EnRouteRoute
          })
const EnForgotPasswordRoute = EnForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => EnRouteRoute
          })
const EnCreateRoute = EnCreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => EnRouteRoute
          })
const EnCookiesRoute = EnCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => EnRouteRoute
          })
const EnCompareRoute = EnCompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => EnRouteRoute
          })
const EnBuyAndSellRoute = EnBuyAndSellRouteImport.update({
            id: '/buy-and-sell',path: '/buy-and-sell',getParentRoute: () => EnRouteRoute
          })
const EnBusinessesRoute = EnBusinessesRouteImport.update({
            id: '/businesses',path: '/businesses',getParentRoute: () => EnRouteRoute
          })
const EnAboutRoute = EnAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => EnRouteRoute
          })
const AuthenticatedStatistikRoute = AuthenticatedStatistikRouteImport.update({
            id: '/statistik',path: '/statistik',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSparadeRoute = AuthenticatedSparadeRouteImport.update({
            id: '/sparade',path: '/sparade',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProfilRoute = AuthenticatedProfilRouteImport.update({
            id: '/profil',path: '/profil',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOversiktRoute = AuthenticatedOversiktRouteImport.update({
            id: '/oversikt',path: '/oversikt',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMinaPrylarRoute = AuthenticatedMinaPrylarRouteImport.update({
            id: '/mina-prylar',path: '/mina-prylar',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMinaBudRoute = AuthenticatedMinaBudRouteImport.update({
            id: '/mina-bud',path: '/mina-bud',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMinaArendenRoute = AuthenticatedMinaArendenRouteImport.update({
            id: '/mina-arenden',path: '/mina-arenden',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMinaAnnonserRoute = AuthenticatedMinaAnnonserRouteImport.update({
            id: '/mina-annonser',path: '/mina-annonser',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMinaAffarerRoute = AuthenticatedMinaAffarerRouteImport.update({
            id: '/mina-affarer',path: '/mina-affarer',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMinNivaRoute = AuthenticatedMinNivaRouteImport.update({
            id: '/min-niva',path: '/min-niva',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMeddelandenRoute = AuthenticatedMeddelandenRouteImport.update({
            id: '/meddelanden',path: '/meddelanden',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLyftRoute = AuthenticatedLyftRouteImport.update({
            id: '/lyft',path: '/lyft',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedKontoRoute = AuthenticatedKontoRouteImport.update({
            id: '/konto',path: '/konto',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedForetagsverktygRoute = AuthenticatedForetagsverktygRouteImport.update({
            id: '/foretagsverktyg',path: '/foretagsverktyg',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBevakningarRoute = AuthenticatedBevakningarRouteImport.update({
            id: '/bevakningar',path: '/bevakningar',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdresserRoute = AuthenticatedAdresserRouteImport.update({
            id: '/adresser',path: '/adresser',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedRedigeraSlugRoute = AuthenticatedRedigeraSlugRouteImport.update({
            id: '/redigera/$slug',path: '/redigera/$slug',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOrderIdRoute = AuthenticatedOrderIdRouteImport.update({
            id: '/order/$id',path: '/order/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedKvittoIdRoute = AuthenticatedKvittoIdRouteImport.update({
            id: '/kvitto/$id',path: '/kvitto/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminTvisterRoute = AuthenticatedAdminTvisterRouteImport.update({
            id: '/tvister',path: '/tvister',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSupportRoute = AuthenticatedAdminSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminStatistikRoute = AuthenticatedAdminStatistikRouteImport.update({
            id: '/statistik',path: '/statistik',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSokordRoute = AuthenticatedAdminSokordRouteImport.update({
            id: '/sokord',path: '/sokord',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSkannlabbRoute = AuthenticatedAdminSkannlabbRouteImport.update({
            id: '/skannlabb',path: '/skannlabb',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSidorRoute = AuthenticatedAdminSidorRouteImport.update({
            id: '/sidor',path: '/sidor',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminRevisionsloggRoute = AuthenticatedAdminRevisionsloggRouteImport.update({
            id: '/revisionslogg',path: '/revisionslogg',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminPushnotiserRoute = AuthenticatedAdminPushnotiserRouteImport.update({
            id: '/pushnotiser',path: '/pushnotiser',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminPlankostnaderRoute = AuthenticatedAdminPlankostnaderRouteImport.update({
            id: '/plankostnader',path: '/plankostnader',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminOrdrarRoute = AuthenticatedAdminOrdrarRouteImport.update({
            id: '/ordrar',path: '/ordrar',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminModereringRoute = AuthenticatedAdminModereringRouteImport.update({
            id: '/moderering',path: '/moderering',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMejlRoute = AuthenticatedAdminMejlRouteImport.update({
            id: '/mejl',path: '/mejl',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMarknadsminneRoute = AuthenticatedAdminMarknadsminneRouteImport.update({
            id: '/marknadsminne',path: '/marknadsminne',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminLanderRoute = AuthenticatedAdminLanderRouteImport.update({
            id: '/lander',path: '/lander',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminKonRoute = AuthenticatedAdminKonRouteImport.update({
            id: '/kon',path: '/kon',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminForetagRoute = AuthenticatedAdminForetagRouteImport.update({
            id: '/foretag',path: '/foretag',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminButiksunderlagRoute = AuthenticatedAdminButiksunderlagRouteImport.update({
            id: '/butiksunderlag',path: '/butiksunderlag',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminBrandingRoute = AuthenticatedAdminBrandingRouteImport.update({
            id: '/branding',path: '/branding',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminBlocketRoute = AuthenticatedAdminBlocketRouteImport.update({
            id: '/blocket',path: '/blocket',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminBildsokRoute = AuthenticatedAdminBildsokRouteImport.update({
            id: '/bildsok',path: '/bildsok',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminBetalningFraktRoute = AuthenticatedAdminBetalningFraktRouteImport.update({
            id: '/betalning-frakt',path: '/betalning-frakt',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAppunderlagRoute = AuthenticatedAdminAppunderlagRouteImport.update({
            id: '/appunderlag',path: '/appunderlag',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminApplageRoute = AuthenticatedAdminApplageRouteImport.update({
            id: '/applage',path: '/applage',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAnvandareRoute = AuthenticatedAdminAnvandareRouteImport.update({
            id: '/anvandare',path: '/anvandare',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAnnonserRoute = AuthenticatedAdminAnnonserRouteImport.update({
            id: '/annonser',path: '/annonser',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAnmalningarRoute = AuthenticatedAdminAnmalningarRouteImport.update({
            id: '/anmalningar',path: '/anmalningar',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAiKostnaderRoute = AuthenticatedAdminAiKostnaderRouteImport.update({
            id: '/ai-kostnader',path: '/ai-kostnader',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminVisaSomUserIdRoute = AuthenticatedAdminVisaSomUserIdRouteImport.update({
            id: '/visa-som/$userId',path: '/visa-som/$userId',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminTvisterIdRoute = AuthenticatedAdminTvisterIdRouteImport.update({
            id: '/tvister_/$id',path: '/tvister/$id',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminOrdrarIdRoute = AuthenticatedAdminOrdrarIdRouteImport.update({
            id: '/ordrar_/$id',path: '/ordrar/$id',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAnvandareUserIdRoute = AuthenticatedAdminAnvandareUserIdRouteImport.update({
            id: '/anvandare_/$userId',path: '/anvandare/$userId',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAnnonsSlugRoute = AuthenticatedAdminAnnonsSlugRouteImport.update({
            id: '/annons/$slug',path: '/annons/$slug',getParentRoute: () => AuthenticatedAdminRouteRoute
          })





const AuthenticatedAdminRouteRouteChildren = {
  AuthenticatedAdminAiKostnaderRoute: AuthenticatedAdminAiKostnaderRoute,AuthenticatedAdminAnmalningarRoute: AuthenticatedAdminAnmalningarRoute,AuthenticatedAdminAnnonserRoute: AuthenticatedAdminAnnonserRoute,AuthenticatedAdminAnvandareRoute: AuthenticatedAdminAnvandareRoute,AuthenticatedAdminApplageRoute: AuthenticatedAdminApplageRoute,AuthenticatedAdminAppunderlagRoute: AuthenticatedAdminAppunderlagRoute,AuthenticatedAdminBetalningFraktRoute: AuthenticatedAdminBetalningFraktRoute,AuthenticatedAdminBildsokRoute: AuthenticatedAdminBildsokRoute,AuthenticatedAdminBlocketRoute: AuthenticatedAdminBlocketRoute,AuthenticatedAdminBrandingRoute: AuthenticatedAdminBrandingRoute,AuthenticatedAdminButiksunderlagRoute: AuthenticatedAdminButiksunderlagRoute,AuthenticatedAdminForetagRoute: AuthenticatedAdminForetagRoute,AuthenticatedAdminKonRoute: AuthenticatedAdminKonRoute,AuthenticatedAdminLanderRoute: AuthenticatedAdminLanderRoute,AuthenticatedAdminMarknadsminneRoute: AuthenticatedAdminMarknadsminneRoute,AuthenticatedAdminMejlRoute: AuthenticatedAdminMejlRoute,AuthenticatedAdminModereringRoute: AuthenticatedAdminModereringRoute,AuthenticatedAdminOrdrarRoute: AuthenticatedAdminOrdrarRoute,AuthenticatedAdminPlankostnaderRoute: AuthenticatedAdminPlankostnaderRoute,AuthenticatedAdminPushnotiserRoute: AuthenticatedAdminPushnotiserRoute,AuthenticatedAdminRevisionsloggRoute: AuthenticatedAdminRevisionsloggRoute,AuthenticatedAdminSidorRoute: AuthenticatedAdminSidorRoute,AuthenticatedAdminSkannlabbRoute: AuthenticatedAdminSkannlabbRoute,AuthenticatedAdminSokordRoute: AuthenticatedAdminSokordRoute,AuthenticatedAdminStatistikRoute: AuthenticatedAdminStatistikRoute,AuthenticatedAdminSupportRoute: AuthenticatedAdminSupportRoute,AuthenticatedAdminTvisterRoute: AuthenticatedAdminTvisterRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminAnnonsSlugRoute: AuthenticatedAdminAnnonsSlugRoute,AuthenticatedAdminAnvandareUserIdRoute: AuthenticatedAdminAnvandareUserIdRoute,AuthenticatedAdminOrdrarIdRoute: AuthenticatedAdminOrdrarIdRoute,AuthenticatedAdminTvisterIdRoute: AuthenticatedAdminTvisterIdRoute,AuthenticatedAdminVisaSomUserIdRoute: AuthenticatedAdminVisaSomUserIdRoute
}

const AuthenticatedAdminRouteRouteWithChildren = AuthenticatedAdminRouteRoute._addFileChildren(AuthenticatedAdminRouteRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,AuthenticatedAdresserRoute: AuthenticatedAdresserRoute,AuthenticatedBevakningarRoute: AuthenticatedBevakningarRoute,AuthenticatedForetagsverktygRoute: AuthenticatedForetagsverktygRoute,AuthenticatedKontoRoute: AuthenticatedKontoRoute,AuthenticatedLyftRoute: AuthenticatedLyftRoute,AuthenticatedMeddelandenRoute: AuthenticatedMeddelandenRoute,AuthenticatedMinNivaRoute: AuthenticatedMinNivaRoute,AuthenticatedMinaAffarerRoute: AuthenticatedMinaAffarerRoute,AuthenticatedMinaAnnonserRoute: AuthenticatedMinaAnnonserRoute,AuthenticatedMinaArendenRoute: AuthenticatedMinaArendenRoute,AuthenticatedMinaBudRoute: AuthenticatedMinaBudRoute,AuthenticatedMinaPrylarRoute: AuthenticatedMinaPrylarRoute,AuthenticatedOversiktRoute: AuthenticatedOversiktRoute,AuthenticatedProfilRoute: AuthenticatedProfilRoute,AuthenticatedSparadeRoute: AuthenticatedSparadeRoute,AuthenticatedStatistikRoute: AuthenticatedStatistikRoute,AuthenticatedKvittoIdRoute: AuthenticatedKvittoIdRoute,AuthenticatedOrderIdRoute: AuthenticatedOrderIdRoute,AuthenticatedRedigeraSlugRoute: AuthenticatedRedigeraSlugRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const EnRouteRouteChildren = {
  EnAboutRoute: EnAboutRoute,EnBusinessesRoute: EnBusinessesRoute,EnBuyAndSellRoute: EnBuyAndSellRoute,EnCompareRoute: EnCompareRoute,EnCookiesRoute: EnCookiesRoute,EnCreateRoute: EnCreateRoute,EnForgotPasswordRoute: EnForgotPasswordRoute,EnGuidesRoute: EnGuidesRoute,EnHowItWorksRoute: EnHowItWorksRoute,EnListingsRoute: EnListingsRoute,EnPricingRoute: EnPricingRoute,EnPrivacyRoute: EnPrivacyRoute,EnRulesRoute: EnRulesRoute,EnSupportRoute: EnSupportRoute,EnTermsRoute: EnTermsRoute,EnTipsRoute: EnTipsRoute,EnVideoScanRoute: EnVideoScanRoute,EnWhyItCostsRoute: EnWhyItCostsRoute,EnIndexRoute: EnIndexRoute
}

const EnRouteRouteWithChildren = EnRouteRoute._addFileChildren(EnRouteRouteChildren)




const EsRouteRouteChildren = {
  EsAnunciosRoute: EsAnunciosRoute,EsComoFuncionaRoute: EsComoFuncionaRoute,EsCompararRoute: EsCompararRoute,EsComprarYVenderRoute: EsComprarYVenderRoute,EsConsejosRoute: EsConsejosRoute,EsCookiesRoute: EsCookiesRoute,EsCrearRoute: EsCrearRoute,EsEmpresasRoute: EsEmpresasRoute,EsEscaneoVideoRoute: EsEscaneoVideoRoute,EsGuiasRoute: EsGuiasRoute,EsOlvideContrasenaRoute: EsOlvideContrasenaRoute,EsPorQueCuestaRoute: EsPorQueCuestaRoute,EsPreciosRoute: EsPreciosRoute,EsPrivacidadRoute: EsPrivacidadRoute,EsReglasRoute: EsReglasRoute,EsSobreNosotrosRoute: EsSobreNosotrosRoute,EsSoporteRoute: EsSoporteRoute,EsTerminosRoute: EsTerminosRoute,EsIndexRoute: EsIndexRoute
}

const EsRouteRouteWithChildren = EsRouteRoute._addFileChildren(EsRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,EnRouteRoute: EnRouteRouteWithChildren,EsRouteRoute: EsRouteRouteWithChildren,SplatRoute: SplatRoute,AnnonserRoute: AnnonserRoute,AnvandarvillkorRoute: AnvandarvillkorRoute,BekraftadRoute: BekraftadRoute,CookiepolicyRoute: CookiepolicyRoute,GlomtLosenordRoute: GlomtLosenordRoute,IntegritetspolicyRoute: IntegritetspolicyRoute,OmRoute: OmRoute,PriserRoute: PriserRoute,ReglerRoute: ReglerRoute,ResetPasswordRoute: ResetPasswordRoute,SaFungerarDetRoute: SaFungerarDetRoute,SkapaRoute: SkapaRoute,SupportRoute: SupportRoute,TipsRoute: TipsRoute,VarforKostarDetRoute: VarforKostarDetRoute,VideoskanningRoute: VideoskanningRoute,ASlugRoute: ASlugRoute,ForetagSlugRoute: ForetagSlugRoute,ForetagListaRoute: ForetagListaRoute,GuiderSlugRoute: GuiderSlugRoute,JamforTjanstRoute: JamforTjanstRoute,KopaOchSaljaOrtRoute: KopaOchSaljaOrtRoute,OrderSparningTrackingRoute: OrderSparningTrackingRoute,SaljaKategoriRoute: SaljaKategoriRoute,ForetagIndexRoute: ForetagIndexRoute,GuiderIndexRoute: GuiderIndexRoute,JamforIndexRoute: JamforIndexRoute,KopaOchSaljaIndexRoute: KopaOchSaljaIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)